
































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobDetail } from '@/@types/LibraryComponent';
import OrganizationIconTooltip from '@/components/common/OrganizationIconTooltip.vue';
import OrganizationNameTooltip from '@/components/common/OrganizationNameTooltip.vue';

@Component({
  components: {
    OrganizationIconTooltip,
    OrganizationNameTooltip,
  },
})
export default class JobTitle extends Vue {
  @Prop()
  private job!: JobDetail;

  private snsButtonElevation: number = 4;

  private companyname: string = '株式会社ヒプスター';

  private companydetail: string =
    '株式会社ヒプスター \n東京都渋谷区道玄坂1-16−15\n道玄坂NKビル2F\n代表取締役 大石賢司';
}
